import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeGetReceivingProgressByItemIdResponse } from '~/types/receive.types';

type TypeFetchReceivingProgressByItemIdParams = {
  ownerCode: string;
  itemId: string;
};

const fetchReceivingProgressByItemId = async ({
  ownerCode,
  itemId,
}: TypeFetchReceivingProgressByItemIdParams): Promise<TypeGetReceivingProgressByItemIdResponse> => {
  const { data } = await axiosInstance.get<TypeGetReceivingProgressByItemIdResponse>(
    `${API_ENDPOINT.RECEIVE.GET_RECEIVING_PROGRESS_ITEM_ID}/${ownerCode}/progress/${itemId}`
  );
  return data;
};

/**
 * [입고관리 > 입고현황] 입고현황 상세 조회 Mutation Hook
 */
export const useGetReceivingProgressByItemIdMutation = () => {
  return useMutation({
    mutationFn: fetchReceivingProgressByItemId,
  });
};
